import { v4 as uuidv4 } from 'uuid'

const highlightsUtil = (text, highlights, className = '', style = {}) => {
    const splitText = text.split(/(\s+|[.,!?;])/)
    return splitText.map(part => {
        const isHighlighted = highlights.some(highlight =>
            part.trim().toLowerCase() === highlight.toLowerCase()
        )

        return (
            <span key={uuidv4()} className={isHighlighted ? className : ''} style={isHighlighted ? style : {}}>
                {part}
            </span>
        )
    })
}

export default highlightsUtil